import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class ImportedExclusionsPreviewContentWebComponent extends LitElement {
  @property({ type: Array, reflect: true })
  exclusions;

  @property({ type: String, reflect: true })
  informationText;

  protected render() {
    return html`
      <div>
        <p>${this.informationText}</p>
        <table>
          <tr>
            <th>Object type</th>
            <th>Excluded item</th>
            <th>Modules</th>
          </tr>
          ${this.exclusions.map(
            exclusion => html`
              <tr>
                <td>${exclusion.taskType}</td>
                <td>${exclusion.path}</td>
                <td>${exclusion.module}</td>
              </tr>
            `
          )}
        </table>
      </div>
    `;
  }

  static get styles() {
    return styles;
  }
}
